<div class="edt_prfle">
    <div class="ss_login_first">
        <div class="head">
            <p>Registration Required</p>
        </div>
        <div class="body">
            <div class="msg_img_content">
                <p>To get access to “My Exam Dashboard” kindly register for the MTSE 2024-25 Examination</p>
            </div>

            <div class="text-center dashboard_close_soon_btn">
                <button class="btn btn_blue_outline me-3"(click)="closeAlert()">Close</button>
                <button class="btn btn_theme" (click)="register()">Register</button>

            </div>
        </div>
    </div>
</div>